//
// HierarchyDataSet.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import ClosetObject from "../../../ClosetObject";
import "../../../lib";
import "../tree/DataTreeNode";
import "./Hierarchy";
import "../dataset/Column";
import "../dataset/DataSet";

var HierarchyDataSet = createModule("commons_HierarchyDataSet", [78], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getHierarchyForName: [1,7],
        getDataSet: [1],
        getHierarchies: [[1]],
        requiresAdditionalData: [2],
        setDataSet: [0,1],
        _getNormalizedCrossings_oobbo: [1,1,1,2,2,1],
        renameLevelColumns: [0,1],
        getCurrentDrillStateRectangularDataSet: [1],
        getSourceToSummarizedIndices: [[4]],
        getMeasureColumns: [[1]],
        getDataTreeRoot: [1],
        _getNormalizedCrossings_oobbbbbbbbo: [1,1,1,2,2,2,2,2,2,2,2,1],
    },
    {
        _create_oo: [4,[1],[7]],
    },
    ["getNormalizedCrossings"],
    ["_create"]
]);
export default HierarchyDataSet;
